
import { $AjaxJson } from '@/lf'
import { $Urlpath, $UrlApipath } from '@/config/config'
export const Sys_NewRequest = {

    GetSys_New(func, ID) {
        $AjaxJson($UrlApipath + "System/GetSys_New", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddSys_New(func, obj) {
        $AjaxJson($UrlApipath + "System/AddSys_New", obj, function (d) {
            func(d)
        })
    },
    UpdateSys_New(func, obj) {
        $AjaxJson($UrlApipath + "System/UpdateSys_New", obj, function (d) {
            func(d)
        })
    },
    SearchSys_New(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchSys_New", obj, function (d) {
            func(d)
        })
    },
    SearchSys_NewList(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchSys_NewList", obj, function (d) {
            func(d)
        })
    },
    DeleteSys_New(func, ID) {
        $AjaxJson($UrlApipath + "System/DeleteSys_New", { ID: ID }, function (d) {
            func(d)
        })
    },

    SetSys_NewStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "System/SetSys_NewStatus", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },

    SetSys_NewIsTop(func, ID, IsTop) {
        $AjaxJson($UrlApipath + "System/SetSys_NewIsTop", { ID: ID, IsTop: IsTop }, function (d) {
            func(d)
        })
    },
}







export const Sys_NewsTypeRequest = {

    GetSys_NewsType(func, ID) {
        $AjaxJson($UrlApipath + "System/GetSys_NewsType", { ID: ID }, function (d) {
            func(d)
        })
    },
    AddSys_NewsType(func, obj) {
        $AjaxJson($UrlApipath + "System/AddSys_NewsType", obj, function (d) {
            func(d)
        })
    },
    UpdateSys_NewsType(func, obj) {
        $AjaxJson($UrlApipath + "System/UpdateSys_NewsType", obj, function (d) {
            func(d)
        })
    },
    SearchSys_NewsType(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchSys_NewsType", obj, function (d) {
            func(d)
        })
    },
    SearchSys_NewsTypeList(func, obj) {
        $AjaxJson($UrlApipath + "System/SearchSys_NewsTypeList", obj, function (d) {
            func(d)
        })
    },
    DeleteSys_NewsType(func, ID) {
        $AjaxJson($UrlApipath + "System/DeleteSys_NewsType", { ID: ID }, function (d) {
            func(d)
        })
    },

   
}



// WEBPACK FOOTER //
// ./src/request/Sys_New.js